"use client";

import { useEffect } from "react";
import gsap from "gsap";

export default function Preloader() {
  useEffect(() => {
    // Intro animation (runs once)
    gsap.fromTo(
      ".letter",
      { y: 40, opacity: 0 },
      {
        y: 0,
        opacity: 1,
        stagger: 0.08,
        duration: 0.9,
        ease: "power3.out",
      },
    );

    // Infinite loading line
    gsap.fromTo(
      ".loader-line",
      { scaleX: 0 },
      {
        scaleX: 1,
        duration: 1.8,
        ease: "power2.inOut",
        repeat: -1,
        transformOrigin: "left center",
      },
    );

    // Glow pulse
    gsap.to(".loader-line", {
      boxShadow: "0 0 30px #d59726",
      repeat: -1,
      yoyo: true,
      duration: 0.9,
      ease: "sine.inOut",
    });
  }, []);

  return (
    <div className="preloader fixed inset-0 z-50 flex items-center justify-center bg-white overflow-hidden">
      {/* SUBTLE GRID BACKGROUND */}
      <div className="absolute inset-0 bg-[linear-gradient(rgba(0,0,0,0.02)_1px,transparent_1px),linear-gradient(90deg,rgba(0,0,0,0.02)_1px,transparent_1px)] bg-size-[48px_48px]" />

      <div className="relative flex flex-col items-center gap-7">
        {/* LOGO TEXT */}
        <h1 className="flex text-5xl font-bold tracking-[0.28em]">
          {"LogicHub".split("").map((char, i) => (
            <span
              key={i}
              className="letter inline-block text-transparent bg-clip-text bg-linear-to-r from-main-color via-[#d59726] to-[#0f172a]"
            >
              {char}
            </span>
          ))}
        </h1>

        {/* TAGLINE */}
        <p className="text-xs uppercase tracking-[0.35em] text-slate-700/80">
          Engineering Intelligent Systems
        </p>

        {/* LOADER */}
        <div className="relative w-60 h-0.75 overflow-hidden rounded-full bg-slate-200">
          <div className="loader-line absolute inset-0 origin-left bg-linear-to-r from-main-color via-[#d59726] to-[#0f172a]" />
        </div>
      </div>
    </div>
  );
}
